document.addEventListener('DOMContentLoaded', () => {
  const widgets = document.querySelectorAll('.product-offers');
  const drawers = document.querySelectorAll('.product-offers-drawer');
  if (!widgets.length && !drawers.length) return;

  drawers.forEach((drawer) => {
    if (drawer.parentElement !== document.body) {
      const stale = Array.from(document.body.children).find((el) => el !== drawer && el.id === drawer.id);
      if (stale) stale.remove();
      document.body.appendChild(drawer);
    }
  });

  widgets.forEach((widget) => {
    const slider = widget.querySelector('[data-offers-slider]');
    if (!slider) return;
    if (typeof Swiper !== 'undefined') {
      new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        loop: true,
        mousewheel: { forceToAxis: true, releaseOnEdges: true },
      });
    } else {
      slider.classList.add('product-offers-slider--static');
    }
  });

  document.querySelectorAll('.product-offers-code').forEach((button) => {
    button.addEventListener('click', () => {
      const code = button.dataset.offerCode;
      if (!code || button.classList.contains('is-copied') || !navigator.clipboard) return;
      navigator.clipboard.writeText(code).then(() => {
        const label = button.querySelector('.product-offers-code-text');
        if (!label) return;
        button.classList.add('is-copied');
        label.textContent = button.dataset.copiedLabel || 'Copied!';
        setTimeout(() => {
          label.textContent = code;
          button.classList.remove('is-copied');
        }, 2000);
      });
    });
  });

  const openDrawer = (drawer, trigger) => {
    drawer.returnFocusTo = trigger;
    drawer.hidden = false;
    drawer.getBoundingClientRect();
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    trigger.setAttribute('aria-expanded', 'true');
    const closeButton = drawer.querySelector('.product-offers-close');
    if (closeButton) closeButton.focus();
  };

  const closeDrawer = (drawer) => {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => {
      drawer.hidden = true;
    }, 300);
    const trigger = drawer.returnFocusTo;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  };

  document.querySelectorAll('[data-offers-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = document.getElementById(button.getAttribute('aria-controls'));
      if (drawer) openDrawer(drawer, button);
    });
  });

  drawers.forEach((drawer) => {
    drawer.querySelectorAll('[data-offers-close]').forEach((element) => {
      element.addEventListener('click', () => closeDrawer(drawer));
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer(drawer);
    });
  });
});
